import { BuyPassPhase, IWalletState } from '../states'
import { WalletActionTypes, WalletTypeKeys } from '../types'

export const initialWalletState: IWalletState = {
  activePasses: [],
  isFetchingActivePasses: false,
  availablePasses: [],
  isFetchingAvailablePasses: false,
  buyPassPhase: BuyPassPhase.IDLE
}

const wallet = (
  state: IWalletState = initialWalletState,
  action: WalletActionTypes
): IWalletState => {
  switch (action.type) {
    case WalletTypeKeys.FETCHING_ACTIVE_PASSES:
      return { ...state, isFetchingActivePasses: true }
    case WalletTypeKeys.FETCH_ACTIVE_PASSES_SUCCESSFUL:
      return { ...state, isFetchingActivePasses: false, activePasses: action.payload }
    case WalletTypeKeys.FETCHING_AVAILABLE_PASSES:
      return { ...state, isFetchingAvailablePasses: true }
    case WalletTypeKeys.FETCH_AVAILABLE_PASSES_SUCCESSFUL:
      return { ...state, isFetchingAvailablePasses: false, availablePasses: action.payload }
    case WalletTypeKeys.BUYING_PASS:
      return { ...state, buyPassPhase: BuyPassPhase.CREATING }
    case WalletTypeKeys.BUY_PASS_CONFIRMING:
      return { ...state, buyPassPhase: BuyPassPhase.CONFIRMING }
    case WalletTypeKeys.BUY_PASS_POLLING:
      return { ...state, buyPassPhase: BuyPassPhase.POLLING, isFetchingActivePasses: true }
    case WalletTypeKeys.BUY_PASS_SUCCESSFUL:
      return { ...state, buyPassPhase: BuyPassPhase.SUCCESS }
    case WalletTypeKeys.BUY_PASS_FAILED:
      return { ...state, buyPassPhase: BuyPassPhase.FAILED }
    default:
      return state
  }
}

export default wallet
